export default {
  data() {
    return {
      commonFieldProperties: {
        label: '',
        model: '',
        help: '',
        placeholder: '',
        fieldOptions: {},
      },

      vfgFields: [
        {
          name: 'Group',
          field: {
            type: 'group',
            legend: '',
            styleClasses: 'subgroup',
            tag: 'fieldset',
            fields: [],
          },
        },
        {
          name: 'Input',
          field: {
            type: 'input',
            fieldOptions: {
              inputType: 'text',
            },
          },
        },
        {
          name: 'Checkbox',
          field: {
            type: 'checkbox',
            // values: [],
          },
        },
        {
          name: 'Radios',
          field: {
            type: 'radios',
            fieldOptions: {
              value: 'value',
              name: 'name',
            },
            values: [],
          },
        },
        {
          name: 'TextArea',
          field: {
            type: 'textArea',
            hint: 'Max 500 characters',
            fieldOptions: {
              max: 500,
              rows: 4,
            },
          },
        },
        {
          name: 'Checklist',
          field: {
            type: 'checklist',
            fieldOptions: {
              listBox: false,
            },
            values: [],
          },
        },
        {
          name: 'Switch',
          field: {
            type: 'switch',
            fieldOptions: {
              //   textOn: 'Female',
              //   textOff: 'Male',
              //   valueOn: 'female',
              //   valueOff: 'male',
            },
          },
        },
        {
          name: 'Select',
          field: {
            type: 'select',
            fieldOptions: {
              noneSelectedText: '',
            },
            values: [],
          },
        },
        {
          name: 'VueMultiSelect',
          field: {
            type: 'vueMultiSelect',
            fieldOptions: {
              multiple: false,
              // max: 4,
              // id:25,
              trackBy: 'name',
              label: 'name',
              searchable: true,
              clearOnSelect: true,
              hideSelected: true,
              // maxHeight:300,
              // allowEmpty:true,
              resetAfter: false,
              closeOnSelect: true,
              taggable: true,
              showPointer: true,
            },
            values: [],
          },
        },
      ],
      // vfgCustomFields: [
      //   // custom fields
      //   {
      //     name: 'ToggleButton',
      //     custom: true,
      //     field: {
      //       type: 'toggle-button',
      //     },
      //   },
      //   {
      //     name: 'DateTime',
      //     custom: true,
      //     field: {
      //       type: 'datetime-picker',
      //     },
      //   },
      //   {
      //     name: 'Calendar',
      //     custom: true,
      //     field: {
      //       type: 'calendar',
      //     },
      //   },
      //   {
      //     name: 'Slider',
      //     custom: true,
      //     field: {
      //       type: 'slider-component',
      //     },
      //   },
      // ],
    };
  },

  methods: {
    insertElement(element, properties) {
      // console.log(element);
      let schema;

      const commonFieldProperties = JSON.parse(JSON.stringify(this.commonFieldProperties));

      if (element.name === 'Group') {
        schema = JSON.parse(JSON.stringify(Object.assign(element.field, properties)));
      } else {
        schema = JSON.parse(JSON.stringify(Object.assign(commonFieldProperties, element.field, properties)));
      }

      // console.log('properties', properties);
      // console.log('schema', schema);

      this.form.schema.fields.push(schema);
    },
  },
};
